// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#feedback-container .feedback-btn-block {
  position: absolute;
  right: 20px;
  bottom: 20px;
  height: 50px;
  width: 50px;
  border-radius: 17px;
  background-color: var(--56ff);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 9;
}
#feedback-container .feedback-btn-block img {
  height: 25px;
  width: 25px;
}

#feedback-form-container .selection-container {
  position: absolute;
  right: 5px;
  bottom: 0;
  cursor: pointer;
}
#feedback-form-container .upload_img {
  width: 100%;
  outline: none;
  display: flex;
  align-items: start;
  flex-direction: column;
  border: 1px solid var(--dee3);
  border-radius: 8px;
  height: 50px;
  padding: 10px 15px;
  font-size: 14px;
  position: relative;
  cursor: pointer;
  font-weight: 400;
}
#feedback-form-container .upload_img span {
  position: absolute;
  left: 3%;
  top: 50%;
  transform: translateY(-50%);
}
#feedback-form-container .upload_img .upload_icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
#feedback-form-container .upload_img input {
  color: transparent;
  outline: unset;
  height: 100%;
  width: 100%;
  cursor: pointer;
  z-index: 99;
}
#feedback-form-container .upload_img input[type=file]::file-selector-button {
  display: none;
}
#feedback-form-container .upload_img input[type=file]::-ms-browse {
  display: none;
}
#feedback-form-container .input_select {
  position: relative;
}
#feedback-form-container .input_select input {
  padding: 13px 120px 13px 16px !important;
  width: 100%;
}
#feedback-form-container .input_select .css-b62m3t-container {
  position: absolute;
  right: 10px;
  border: none;
  top: 48%;
  min-width: 150px;
}
#feedback-form-container .input_select .css-b62m3t-container .css-13cymwt-control {
  border: none;
}
#feedback-form-container .input_select .css-b62m3t-container .css-13cymwt-control :focus {
  border: none !important;
  box-shadow: none;
}
#feedback-form-container .input_select .css-b62m3t-container .css-t3ipsp-control {
  border: none;
  box-shadow: none;
}
#feedback-form-container .input_select .css-b62m3t-container .css-t3ipsp-control :hover {
  color: unset;
}
#feedback-form-container .input_select .css-b62m3t-container .css-t3ipsp-control .css-qbdosj-Input {
  color: var(--2749);
}
#feedback-form-container .input_select .css-b62m3t-container .css-1xc3v61-indicatorContainer {
  color: var(--2749);
  padding: 0;
}
#feedback-form-container .input_select .css-b62m3t-container .css-1u9des2-indicatorSeparator {
  display: none;
}
#feedback-form-container .input_select .css-b62m3t-container .select__control {
  height: 100%;
}
#feedback-form-container .input_select .css-b62m3t-container .css-1fdsijx-ValueContainer {
  height: 100%;
}
#feedback-form-container .input_select .css-b62m3t-container .css-1fdsijx-ValueContainer input {
  padding: 0 !important;
}
#feedback-form-container .input_select .css-1dimb5e-singleValue {
  font-size: 15px;
}
#feedback-form-container .css-13cymwt-control:focus {
  border: none !important;
}
#feedback-form-container .is-invalid {
  color: red;
}

#dark-form .selection-container {
  position: absolute;
  right: 5px;
  bottom: 0;
  cursor: pointer;
}
#dark-form .upload_img {
  width: 100%;
  outline: none;
  display: flex;
  align-items: start;
  flex-direction: column;
  border: 1px solid var(--4d6c);
  border-radius: 8px;
  height: 50px;
  padding: 10px 15px;
  font-size: 14px;
  position: relative;
  color: var(--ffff);
  background-color: var(--4d6c);
  cursor: pointer;
  font-weight: 400;
}
#dark-form .upload_img span {
  position: absolute;
  left: 3%;
  top: 50%;
  transform: translateY(-50%);
}
#dark-form .upload_img .upload_icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
#dark-form .upload_img input {
  color: transparent;
  outline: unset;
  height: 100%;
  width: 100%;
  cursor: pointer;
  z-index: 99;
}
#dark-form .upload_img input[type=file]::file-selector-button {
  display: none;
}
#dark-form .upload_img input[type=file]::-ms-browse {
  display: none;
}
#dark-form .input_select {
  position: relative;
}
#dark-form .input_select input {
  padding: 13px 120px 13px 16px !important;
  width: 100%;
  color: var(--ffff);
}
#dark-form .input_select input::placeholder {
  color: var(--ffff);
}
#dark-form .input_select .css-b62m3t-container {
  position: absolute;
  right: 10px;
  border: none;
  top: 48%;
  min-width: 150px;
}
#dark-form .input_select .css-b62m3t-container .css-13cymwt-control {
  border: none;
}
#dark-form .input_select .css-b62m3t-container .css-13cymwt-control :focus {
  border: none !important;
  box-shadow: none;
}
#dark-form .input_select .css-b62m3t-container .css-t3ipsp-control {
  border: none;
  box-shadow: none;
}
#dark-form .input_select .css-b62m3t-container .css-t3ipsp-control :hover {
  color: unset;
}
#dark-form .input_select .css-b62m3t-container .css-t3ipsp-control .css-qbdosj-Input {
  color: var(--ffff);
}
#dark-form .input_select .css-b62m3t-container .css-1xc3v61-indicatorContainer {
  color: var(--ffff);
  padding: 0;
}
#dark-form .input_select .css-b62m3t-container .css-qbdosj-Input {
  color: var(--ffff);
}
#dark-form .input_select .css-b62m3t-container .css-1u9des2-indicatorSeparator {
  display: none;
}
#dark-form .input_select .css-b62m3t-container .select__control {
  height: 100%;
}
#dark-form .input_select .css-b62m3t-container .css-1fdsijx-ValueContainer {
  height: 100%;
}
#dark-form .input_select .css-b62m3t-container .css-1fdsijx-ValueContainer input {
  padding: 0 !important;
}
#dark-form .input_select .css-1dimb5e-singleValue {
  font-size: 15px;
  color: var(--ffff);
}
#dark-form .css-13cymwt-control:focus {
  border: none !important;
}
#dark-form .is-invalid {
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/Feedback/Feedback.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAAJ;AACI;EACE,YAAA;EACA,WAAA;AACN;;AAIE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AADJ;AAIE;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAII;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;AAFN;AAKI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AAHN;AAMI;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AAJN;AAOI;EACE,aAAA;AALN;AAQI;EACE,aAAA;AANN;AAUE;EACE,kBAAA;AARJ;AAUI;EACE,wCAAA;EACA,WAAA;AARN;AAWI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AATN;AAWM;EACE,YAAA;AATR;AAUQ;EACE,uBAAA;EACA,gBAAA;AARV;AAYM;EACE,YAAA;EACA,gBAAA;AAVR;AAYQ;EACE,YAAA;AAVV;AAaQ;EACE,kBAAA;AAXV;AAcM;EACE,kBAAA;EACA,UAAA;AAZR;AAeM;EACE,aAAA;AAbR;AAeM;EACE,YAAA;AAbR;AAeM;EACE,YAAA;AAbR;AAcQ;EACE,qBAAA;AAZV;AAiBI;EACE,eAAA;AAfN;AAmBE;EACE,uBAAA;AAjBJ;AAoBE;EACE,UAAA;AAlBJ;;AAuBE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AApBJ;AAuBE;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AArBJ;AAsBI;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;AApBN;AAsBI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AApBN;AAsBI;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AApBN;AAuBI;EACE,aAAA;AArBN;AAwBI;EACE,aAAA;AAtBN;AA0BE;EACE,kBAAA;AAxBJ;AA0BI;EACE,wCAAA;EACA,WAAA;EACA,kBAAA;AAxBN;AAyBM;EACE,kBAAA;AAvBR;AA2BI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AAzBN;AA2BM;EACE,YAAA;AAzBR;AA0BQ;EACE,uBAAA;EACA,gBAAA;AAxBV;AA4BM;EACE,YAAA;EACA,gBAAA;AA1BR;AA4BQ;EACE,YAAA;AA1BV;AA6BQ;EACE,kBAAA;AA3BV;AA8BM;EACE,kBAAA;EACA,UAAA;AA5BR;AA8BM;EACE,kBAAA;AA5BR;AA8BM;EACE,aAAA;AA5BR;AA8BM;EACE,YAAA;AA5BR;AA8BM;EACE,YAAA;AA5BR;AA6BQ;EACE,qBAAA;AA3BV;AA+BI;EACE,eAAA;EACA,kBAAA;AA7BN;AAiCE;EACE,uBAAA;AA/BJ;AAkCE;EACE,UAAA;AAhCJ","sourcesContent":["#feedback-container {\r\n  .feedback-btn-block {\r\n    position: absolute;\r\n    right: 20px;\r\n    bottom: 20px;\r\n    height: 50px;\r\n    width: 50px;\r\n    border-radius: 17px;\r\n    background-color: var(--56ff);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    z-index: 9;\r\n    img {\r\n      height: 25px;\r\n      width: 25px;\r\n    }\r\n  }\r\n}\r\n#feedback-form-container {\r\n  .selection-container {\r\n    position: absolute;\r\n    right: 5px;\r\n    bottom: 0;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .upload_img {\r\n    width: 100%;\r\n    outline: none;\r\n    display: flex;\r\n    align-items: start;\r\n    flex-direction: column;\r\n    border: 1px solid var(--dee3);\r\n    border-radius: 8px;\r\n    height: 50px;\r\n    padding: 10px 15px;\r\n    font-size: 14px;\r\n    position: relative;\r\n    cursor: pointer;\r\n    font-weight: 400;\r\n\r\n    span {\r\n      position: absolute;\r\n      left: 3%;\r\n      top: 50%;\r\n      transform: translateY(-50%);\r\n    }\r\n\r\n    .upload_icon {\r\n      position: absolute;\r\n      right: 10px;\r\n      top: 50%;\r\n      transform: translateY(-50%);\r\n    }\r\n\r\n    input {\r\n      color: transparent;\r\n      outline: unset;\r\n      height: 100%;\r\n      width: 100%;\r\n      cursor: pointer;\r\n      z-index: 99;\r\n    }\r\n\r\n    input[type=\"file\"]::file-selector-button {\r\n      display: none;\r\n    }\r\n\r\n    input[type=\"file\"]::-ms-browse {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .input_select {\r\n    position: relative;\r\n\r\n    input {\r\n      padding: 13px 120px 13px 16px !important;\r\n      width: 100%;\r\n    }\r\n\r\n    .css-b62m3t-container {\r\n      position: absolute;\r\n      right: 10px;\r\n      border: none;\r\n      top: 48%;\r\n      min-width: 150px;\r\n\r\n      .css-13cymwt-control {\r\n        border: none;\r\n        :focus {\r\n          border: none !important;\r\n          box-shadow: none;\r\n        }\r\n      }\r\n\r\n      .css-t3ipsp-control {\r\n        border: none;\r\n        box-shadow: none;\r\n\r\n        :hover {\r\n          color: unset;\r\n        }\r\n\r\n        .css-qbdosj-Input {\r\n          color: var(--2749);\r\n        }\r\n      }\r\n      .css-1xc3v61-indicatorContainer {\r\n        color: var(--2749);\r\n        padding: 0;\r\n      }\r\n\r\n      .css-1u9des2-indicatorSeparator {\r\n        display: none;\r\n      }\r\n      .select__control {\r\n        height: 100%;\r\n      }\r\n      .css-1fdsijx-ValueContainer {\r\n        height: 100%;\r\n        input {\r\n          padding: 0 !important;\r\n        }\r\n      }\r\n    }\r\n\r\n    .css-1dimb5e-singleValue {\r\n      font-size: 15px;\r\n    }\r\n  }\r\n\r\n  .css-13cymwt-control:focus {\r\n    border: none !important;\r\n  }\r\n\r\n  .is-invalid {\r\n    color: red;\r\n  }\r\n}\r\n\r\n#dark-form {\r\n  .selection-container {\r\n    position: absolute;\r\n    right: 5px;\r\n    bottom: 0;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .upload_img {\r\n    width: 100%;\r\n    outline: none;\r\n    display: flex;\r\n    align-items: start;\r\n    flex-direction: column;\r\n    border: 1px solid var(--4d6c);\r\n    border-radius: 8px;\r\n    height: 50px;\r\n    padding: 10px 15px;\r\n    font-size: 14px;\r\n    position: relative;\r\n    color: var(--ffff);\r\n    background-color: var(--4d6c);\r\n    cursor: pointer;\r\n    font-weight: 400;\r\n    span {\r\n      position: absolute;\r\n      left: 3%;\r\n      top: 50%;\r\n      transform: translateY(-50%);\r\n    }\r\n    .upload_icon {\r\n      position: absolute;\r\n      right: 10px;\r\n      top: 50%;\r\n      transform: translateY(-50%);\r\n    }\r\n    input {\r\n      color: transparent;\r\n      outline: unset;\r\n      height: 100%;\r\n      width: 100%;\r\n      cursor: pointer;\r\n      z-index: 99;\r\n    }\r\n\r\n    input[type=\"file\"]::file-selector-button {\r\n      display: none;\r\n    }\r\n\r\n    input[type=\"file\"]::-ms-browse {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .input_select {\r\n    position: relative;\r\n\r\n    input {\r\n      padding: 13px 120px 13px 16px !important;\r\n      width: 100%;\r\n      color: var(--ffff);\r\n      &::placeholder {\r\n        color: var(--ffff);\r\n      }\r\n    }\r\n\r\n    .css-b62m3t-container {\r\n      position: absolute;\r\n      right: 10px;\r\n      border: none;\r\n      top: 48%;\r\n      min-width: 150px;\r\n\r\n      .css-13cymwt-control {\r\n        border: none;\r\n        :focus {\r\n          border: none !important;\r\n          box-shadow: none;\r\n        }\r\n      }\r\n\r\n      .css-t3ipsp-control {\r\n        border: none;\r\n        box-shadow: none;\r\n\r\n        :hover {\r\n          color: unset;\r\n        }\r\n\r\n        .css-qbdosj-Input {\r\n          color: var(--ffff);\r\n        }\r\n      }\r\n      .css-1xc3v61-indicatorContainer {\r\n        color: var(--ffff);\r\n        padding: 0;\r\n      }\r\n      .css-qbdosj-Input {\r\n        color: var(--ffff);\r\n      }\r\n      .css-1u9des2-indicatorSeparator {\r\n        display: none;\r\n      }\r\n      .select__control {\r\n        height: 100%;\r\n      }\r\n      .css-1fdsijx-ValueContainer {\r\n        height: 100%;\r\n        input {\r\n          padding: 0 !important;\r\n        }\r\n      }\r\n    }\r\n    .css-1dimb5e-singleValue {\r\n      font-size: 15px;\r\n      color: var(--ffff);\r\n    }\r\n  }\r\n\r\n  .css-13cymwt-control:focus {\r\n    border: none !important;\r\n  }\r\n\r\n  .is-invalid {\r\n    color: red;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
